export default __webpack_public_path__ + "static/media/medal-bronze.d1969ca4.svg";